module.exports = __webpack_public_path__ + "img/hr-fluid-wagon-shadow-6.8ac89aeb.png";